import axios from "axios";
import { clearLogoutData } from "../logout/action";
import { Partner_Service_URL } from "./../Url";

export const ProgressActions = {
  GET_PROGRESS_SUCCESS: "GET_PROGRESS_SUCCESS",
  GET_PROGRESS_ERROR: "GET_PROGRESS_ERROR",
};

export const getProgress = (props) => async (dispatch, getState) => {
  const accessToken = props.accessToken ?? getState()?.auth?.idToken;

  const { partnerFirmId } = props;

  return axios({
    method: "post",
    url: `${Partner_Service_URL}/get/partnerFirmProgressDetails/ByPartnerFirmId?partnerFirmId=${partnerFirmId}`,
    headers: {
      authorization: "Bearer " + accessToken,
    },
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        dispatch(getProgressSuccess(response.data.dtoList));
        return response;
      } else if (response.status === 401) {
        return response;
      } else {
        const error = new Error(response.statusText);
        dispatch(getProgressError(error));
        throw error;
      }
    })
    .catch((error) => {
      if (error.response) {
        dispatch(getProgressError(error));
      }
      throw error;
    });
};

export function getProgressError(error) {
  return {
    type: ProgressActions.GET_PROGRESS_ERROR,
    payload: error,
  };
}

export function getProgressSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: ProgressActions.GET_PROGRESS_SUCCESS,
      payload: props,
    });
  };
}
